import { generator } from './generator';
import { parser } from './parser';
import { tokenizer } from './tokenizer';
import { transformer } from './transformer';
export var compile = function compile(x) {
  return generator(transformer(parser(tokenizer(x))));
};